import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b6d4c34"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 0,
  class: "countdown-box"
}
const _hoisted_3 = { class: "countdown-value" }
const _hoisted_4 = { class: "countdown-label" }
const _hoisted_5 = {
  key: 1,
  class: "detail-button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return ($props.items.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "banner-swiper-box",
        style: _normalizeStyle($setup.boxStyle)
      }, [
        _createVNode(_component_van_swipe, {
          class: "banner-swiper",
          style: _normalizeStyle($setup.swipeStyle),
          autoplay: $props.autoplay,
          "lazy-render": "",
          width: $props.width,
          height: $props.height,
          onChange: $setup.onChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, {
                key: item.id,
                onClick: ($event: any) => ($setup.onClick(item))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: $setup.getImageUrl(item),
                    class: "banner-swiper-image",
                    alt: $setup.getTitle(item)
                  }, null, 8 /* PROPS */, _hoisted_1),
                  ($setup.shouldShowCountdown(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countdownItems(item), (countdownItem) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: countdownItem.label,
                            class: "countdown-card"
                          }, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(countdownItem.value), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(countdownItem.label), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($props.showDetailButton && item.jump_type != 0)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_5, _toDisplayString(_ctx.$t('查看详情')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["style", "autoplay", "width", "height"])
      ], 4 /* STYLE */))
    : _createCommentVNode("v-if", true)
}